import { isDefined } from "../components/Generic/IsDefined";

export function getFullName<
  T extends { firstName: string; middleName?: string | null; lastName: string }
>(entity: T) {
  let name = entity.firstName;

  if (isDefined(entity.middleName) && entity.middleName.length > 0) {
    name += ` ${entity.middleName.charAt(0)}.`;
  }

  return name + ` ${entity.lastName}`;
}
